import React, { useId } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useModalLayer } from '../hooks/useModalLayer';

interface AuthRequiredModalProps {
  open: boolean;
  onClose: () => void;
  onSignIn: () => void;
}

const AuthRequiredModal: React.FC<AuthRequiredModalProps> = ({ open, onClose, onSignIn }) => {
  const titleId = useId();
  useModalLayer(open, onClose);

  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.5 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black z-40"
            onClick={onClose}
            aria-hidden
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 10 }}
            transition={{ type: 'spring', stiffness: 260, damping: 20 }}
            className="fixed inset-0 z-50 flex items-center justify-center px-4 pointer-events-none"
          >
            <div
              role="dialog"
              aria-modal="true"
              aria-labelledby={titleId}
              className="w-full max-w-md rounded-2xl bg-dark-lighter border border-white/10 shadow-2xl p-6 pointer-events-auto"
              onClick={(e) => e.stopPropagation()}
            >
              <h2 id={titleId} className="text-2xl font-bold mb-3">
                Sign in to check out
              </h2>
              <p className="text-gray-400 mb-6">
                You need an account so we can attach your purchases and downloads to your profile.
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <button
                  type="button"
                  onClick={onSignIn}
                  className="flex-1 neon-button-blue px-4 py-2 rounded-full font-medium"
                >
                  Sign in / Create account
                </button>
                <button
                  type="button"
                  onClick={onClose}
                  className="flex-1 px-4 py-2 rounded-full border border-white/20 hover:bg-white/5 text-sm font-medium"
                >
                  Continue browsing
                </button>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default AuthRequiredModal;

